module.exports = __webpack_public_path__ + "img/ml.85694bff.jpg";